import React from 'react';
import { makeStyles } from '@material-ui/core/styles';
import PropTypes from 'prop-types';
import { GroupWork } from '@material-ui/icons';
import Table from '@material-ui/core/Table';
import TableBody from '@material-ui/core/TableBody';
import TableCell from '@material-ui/core/TableCell';
import TableContainer from '@material-ui/core/TableContainer';
import TableHead from '@material-ui/core/TableHead';
import TableRow from '@material-ui/core/TableRow';
import Paper from '@material-ui/core/Paper';
import Box from '@material-ui/core/Box';
import { Tooltip, Button } from '@material-ui/core';
import { convertDateToPST } from '../../../../helpers/audit-trail';

const useStyles = makeStyles({
  table: {
    minWidth: 650,
  },
  groupName: {
    fontStyle: 'normal',
    fontWeight: '400',
    fontSize: '20px',
    lineHeight: '27px',
    color: '#262626',
  },
  groupNameDark: {
    fontStyle: 'normal',
    fontWeight: '400',
    fontSize: '20px',
    lineHeight: '27px',
    color: '#fff',
    marginTop: '0px',
  },
  groupWorkIconSpan: {
    marginRight: '6px',
    verticalAlign: 'middle',
  },
  groupWorkIcon: {
    color: '#9c27b0',
    width: '23px',
    height: '23px',
  },
  groupWorkIconDark: {
    color: '#ba68c8',
    width: '23px',
    height: '23px',
  },
  tableHead: {
    backgroundColor: '#F5F7F7',
    border: '1px solid #BDC3C7',
    width: '859px',
    height: '43px',
    boxSizing: 'border-box',
  },
  tableHeadDark: {
    backgroundColor: '#212121',
    border: '1px solid #515151',
    width: '859px',
    height: '43px',
    boxSizing: 'border-box',
  },
  tableRow: {
    backgroundColor: '#FCFDFE',
    border: '1px solid #BDC3C7',
    width: '857px',
    maxHeight: '52px',
    textOverflow: 'ellipsis',
  },
  tableRowDark: {
    backgroundColor: '#FCFDFE',
    border: '1px solid #515151',
    width: '857px',
    maxHeight: '52px',
    textOverflow: 'ellipsis',
  },
  tableCell: {
    fontStyle: 'normal',
    fontWeight: '400',
    fontSize: '12px',
    lineHeight: '19px',
    overflow: 'hidden',
    textOverflow: 'ellipsis',
    width: '11rem',
    whiteSpace: 'nowrap',
  },
  tableCellDark: {
    backgroundColor: '#424242',
    fontStyle: 'normal',
    fontWeight: '400',
    fontSize: '12px',
    lineHeight: '19px',
    overflow: 'hidden',
    textOverflow: 'ellipsis',
    width: '11rem',
    whiteSpace: 'nowrap',
  },
  changeCell: {
    maxWidth: '43px',
  },
});

const GroupTable = props => {
  const { groupsInfo = [], paletteType, displayGroupMode, displayGroup } = props;

  const classes = useStyles();

  return (
    <div style={{ marginBottom: '23px' }}>
      <Box>
        <p className={paletteType === 'dark' ? classes.groupNameDark : classes.groupName}>
          <span className={classes.groupWorkIconSpan}>
            <GroupWork className={paletteType === 'dark' ? classes.groupWorkIconDark : classes.groupWorkIcon} />
          </span>
          {groupsInfo && groupsInfo.length > 0 && <div>{groupsInfo.slice(-1)[0].group_name}</div>}
        </p>
      </Box>
      <TableContainer component={Paper}>
        <Table className={classes.table}>
          <TableHead className={classes.tableHead}>
            <TableRow>
              <TableCell
                className={paletteType === 'dark' ? classes.tableHeadDark : classes.tableCell}
                style={{ width: '124px' }}
              >
                Change
              </TableCell>
              <TableCell
                className={paletteType === 'dark' ? classes.tableHeadDark : classes.tableCell}
                style={{ width: '98px' }}
              >
                Old Value
              </TableCell>
              <TableCell
                className={paletteType === 'dark' ? classes.tableHeadDark : classes.tableCell}
                style={{ width: '105px' }}
              >
                New Value
              </TableCell>
              <TableCell
                className={paletteType === 'dark' ? classes.tableHeadDark : classes.tableCell}
                style={{ width: '120px' }}
              >
                Organization
              </TableCell>
              <TableCell
                className={paletteType === 'dark' ? classes.tableHeadDark : classes.tableCell}
                style={{ width: '197px' }}
              >
                Datetime
              </TableCell>
              <TableCell
                className={paletteType === 'dark' ? classes.tableHeadDark : classes.tableCell}
                style={{ width: '216px' }}
              >
                User
              </TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {groupsInfo.reverse().map(groupInfo => (
              <TableRow className={paletteType === 'dark' ? classes.tableRowDark : classes.tableRow}>
                <TableCell
                  className={paletteType === 'dark' ? classes.tableCellDark : classes.tableCell}
                  style={{ maxWidth: '124px' }}
                >
                  <Tooltip arrow title={<h3>{groupInfo.object_type}</h3>} placement="bottom">
                    <span>{groupInfo.object_type}</span>
                  </Tooltip>
                </TableCell>
                <TableCell
                  className={paletteType === 'dark' ? classes.tableCellDark : classes.tableCell}
                  style={{ maxWidth: '98px' }}
                >
                  <Tooltip title={<h3>{groupInfo.old_value}</h3>} placement="bottom-start">
                    <span>{groupInfo.old_value}</span>
                  </Tooltip>
                </TableCell>
                <TableCell
                  className={paletteType === 'dark' ? classes.tableCellDark : classes.tableCell}
                  style={{ maxWidth: '105px', color: '#9C27B0' }}
                >
                  <Tooltip title={<h3>{groupInfo.new_value}</h3>} placement="bottom-start">
                    <span>{groupInfo.new_value}</span>
                  </Tooltip>
                </TableCell>
                <TableCell
                  className={paletteType === 'dark' ? classes.tableCellDark : classes.tableCell}
                  style={{ maxWidth: '120px' }}
                >
                  <Tooltip arrow title={<h3>{groupInfo.organization_name}</h3>} placement="bottom">
                    <span>{groupInfo.organization_name}</span>
                  </Tooltip>
                </TableCell>
                <TableCell
                  className={paletteType === 'dark' ? classes.tableCellDark : classes.tableCell}
                  style={{ maxWidth: '197px' }}
                >
                  <Tooltip arrow title={<h3>{groupInfo.created_on}</h3>} placement="bottom">
                    <span>{convertDateToPST(groupInfo.created_on)}</span>
                  </Tooltip>
                </TableCell>
                <TableCell
                  className={paletteType === 'dark' ? classes.tableCellDark : classes.tableCell}
                  style={{ maxWidth: '216px' }}
                >
                  <Tooltip arrow title={<h3>{groupInfo.actor_id}</h3>} placement="bottom">
                    <span>{groupInfo.actor_id}</span>
                  </Tooltip>
                </TableCell>
              </TableRow>
            ))}
          </TableBody>
        </Table>
      </TableContainer>
      {displayGroup === '' && groupsInfo && (
        <Button
          variant="text"
          style={{
            float: 'right',
            paddingRight: '5px',
            textTransform: 'capitalize',
            color: paletteType === 'dark' ? '#BA68C8' : '#9C27B0',
          }}
          onClick={() => {
            displayGroupMode(groupsInfo.slice(-1)[0].group_name);
          }}
        >
          View More
        </Button>
      )}
    </div>
  );
};

GroupTable.propTypes = {
  groupsInfo: PropTypes.object.isRequired,
  paletteType: PropTypes.string.isRequired,
  displayGroupMode: PropTypes.func.isRequired,
  displayGroup: PropTypes.string.isRequired,
};

export default GroupTable;
